module.exports = __webpack_public_path__ + "img/webworthy-hero.9e783bb3.jpg";